import React from 'react';
import styles from './jobs_ca_banner.module.scss';
import { SIGN_UP_URL, LOG_IN_URL } from './jobs_ca_constants';

interface Props {
  exclusiveJobs: string | number;
  isSignedIn: boolean;
}

const plausibleSignInTracking = `
  plausible-event-name=click
  plausible-event-intention=paywall-login
  plausible-event-section=exclusive-job
`;

const plausibleUpgradeTracking = `
  plausible-event-name=click
  plausible-event-intention=paywall-join
  plausible-event-section=exclusive-job
`;

const JobsCaBanner = ({ exclusiveJobs, isSignedIn }: Props) => {
  if (typeof exclusiveJobs !== 'number' || exclusiveJobs < 1) return null;

  const returnTo = `return_to=${window.location.pathname}`;
  const signUpReturnToURL = `${SIGN_UP_URL}&${returnTo}`;
  const logInReturnToURL = `${LOG_IN_URL}?${returnTo}`;

  const exclusiveText =
    exclusiveJobs === 1
      ? `${exclusiveJobs} exclusive position`
      : `all ${exclusiveJobs} exclusive positions`;

  const signInLink = !isSignedIn && (
    <div className='d-flex'>
      <p className='mb-0 me-2'>or</p>
      <a
        data-testid='log-in-link'
        href={logInReturnToURL}
        className={`btn btn-link link-gray-orange fw-bold ${plausibleSignInTracking}`}
      >
        Sign in
      </a>
    </div>
  );

  return (
    <div
      data-testid='jobs-ca-banner'
      className={`py-4 px-45 border border-info border-4 rounded ${styles.caBanner}`}
    >
      <div className='mb-2'>
        <h3 className='fs-45 fw-bold m-0'>Don&apos;t miss out on these opportunities!</h3>
      </div>
      <div className={styles.caBannerInfo}>
        <p data-testid='exclusive-jobs-count' className='m-0'>
          Create a Devex Career Account to get access to our complete jobs database, including
          <span className='fw-bold'> {exclusiveText} in this organization </span>and many more.
        </p>
      </div>
      <div className={styles.caBannerButtons}>
        <a
          data-testid='sign-up-link'
          href={signUpReturnToURL}
          className={`btn btn-primary ${plausibleUpgradeTracking}`}
        >
          Sign-up for a Career Account
        </a>
        {signInLink}
      </div>
    </div>
  );
};

export default JobsCaBanner;
